export default "__VITE_ASSET__e80b22ec__"